import { Heading, Rule, VerticalSpace } from '@arc-ui/components';
import { ElsewhereSectionProps } from '../../../types';
import ConsumerLookup from '../ConsumerLookup/ConsumerLookup';

export const ElsewhereSection: React.FC<ElsewhereSectionProps> = ({
  query,
  isMobile,
  isTablet,
}) => (
  <>
    <VerticalSpace size="24" />
    <Heading level="2" size="s">
      Elsewhere
    </Heading>
    <VerticalSpace size="8" />
    <Rule />
    <VerticalSpace size="16" />
    <ConsumerLookup
      query={query}
      isMobile={isMobile ?? false}
      isTablet={isTablet ?? false}
    />
  </>
);
